<nav class="mobile-nav">
  @for (item of navItems(); track item.label) {
    <a
      [routerLink]="item.route"
      routerLinkActive="active"
      class="nav-item"
    >
      @if (item.iconName) {
        <i-feather [name]="item.iconName"></i-feather>
      }
      @if (item.warning) {
        <div class="warning-dot"></div>
      }
    </a>
  }
</nav>
